import * as images from './images'

// Metal collection
export const metalcollection = [
	{
		id: 1,
		image: images.augustburnsred1,
		title: 'Death Below',
		date: 'March 24th, 2023',
		band: 'August Burns Red',
		length: '(53:53)',
		genre: 'MetalCore',
	},
	{
		id: 2,
		image: images.augustburnsred2,
		title: 'Season of surrender',
		date: 'June 05th, 2026',
		band: 'August Burns Red',
		length: '(44:50)',
		genre: 'MetalCore',
	},
	{
		id: 3,
		image: images.blacksabbath1,
		title: 'Heaven and Hell',
		date: 'April 25th, 1980',
		band: 'Black Sabbath',
		length: '(39:48)',
		genre: 'Heavy Metal, Doom Metal',
	},
	{
		id: 4,
		image: images.bloodincantation1,
		title: 'absolute elsewhere',
		date: 'October 4th, 2024',
		band: 'Blood Incantation',
		length: '(43:43)',
		genre: 'Progressive death metal',
	},
	{
		id: 5,
		image: images.bloodincantation2,
		title: 'All Gates Open (Original Motion Picture Soundtrack)',
		date: 'June 05th, 2026',
		band: 'Blood Incantation',
		length: '(61:01)',
		genre: 'Progressive death metal',
	},
	{
		id: 6,
		image: images.borknagar1,
		title: 'Fall',
		date: 'February 23rd, 2024',
		band: 'Borknagar',
		length: '(54:30)',
		genre: 'Progressive Metal',
	},
	{
		id: 7,
		image: images.death1,
		title: 'The sound of perseverence',
		date: 'February 15th, 2011',
		band: 'Death',
		length: '(117:15)',
		genre: 'Death Metal',
	},
	{
		id: 8,
		image: images.dio1,
		title: 'Evil or Divine',
		date: 'February 22nd, 2005',
		band: 'Dio',
		length: '(92:39)',
		genre: 'Heavy Metal',
	},
	{
		id: 9,
		image: images.dio2,
		title: 'Holy Diver',
		date: 'May 15th, 1983',
		band: 'Dio',
		length: '(75:37)',
		genre: 'Heavy Metal',
	},
	{
		id: 10,
		image: images.ironmaiden1,
		title: 'Powerslave',
		date: 'July 23rd, 1984',
		band: 'Iron Maiden',
		length: '(51:12)',
		genre: 'Heavy Metal',
	},
	{
		id: 11,
		image: images.ironmaiden2,
		title: 'Made in England',
		date: 'March 25th, 2013',
		band: 'Iron Maiden',
		length: '(100:22)',
		genre: 'Heavy Metal',
	},
	{
		id: 12,
		image: images.ironmaiden3,
		title: 'The Number of the Beast',
		date: 'March 22nd, 1982',
		band: 'Iron Maiden',
		length: '(40:22)',
		genre: 'Heavy Metal',
	},
	{
		id: 13,
		image: images.ironmaiden4,
		title: 'Life after death',
		date: 'August 01st, 1985',
		band: 'Iron Maiden',
		length: '(102:54)',
		genre: 'Heavy Metal',
	},
	{
		id: 14,
		image: images.ironmaiden5,
		title: 'Infinite Dreams',
		date: 'November 06th, 1989',
		band: 'Iron Maiden',
		length: '(16:15)',
		genre: 'Heavy Metal',
	},
	{
		id: 15,
		image: images.ironmaiden6,
		title: 'Somewhere in time',
		date: 'January 01st, 1986',
		band: 'Iron Maiden',
		length: '(51:41)',
		genre: 'Heavy Metal',
	},
	{
		id: 16,
		image: images.killswitch1,
		title: 'Atonement',
		date: 'August 16th, 2019',
		band: 'Killswitch Engage',
		length: '(39:02)',
		genre: 'Death Metal',
	},
	{
		id: 17,
		image: images.linkinpark1,
		title: 'From zero',
		date: 'November 15th, 2024',
		band: 'Linkin Park',
		length: '(31:54)',
		genre: 'Nu Metal',
	},
	{
		id: 18,
		image: images.linkinpark2,
		title: 'Hybrid Theory',
		date: 'October 24th, 2000',
		band: 'Linkin Park',
		length: '(37:50)',
		genre: 'Nu Metal',
	},
	{
		id: 19,
		image: images.lornashore1,
		title: 'I feel the everblack festering within me',
		date: 'September 29th, 2025',
		band: 'Lorna Shore',
		length: '(66:31)',
		genre: 'Deathcore',
	},
	{
		id: 20,
		image: images.motorhead1,
		title: 'Overnight session',
		date: 'October 15th 1996',
		band: 'Mötorhead',
		length: '(41:19)',
		genre: 'Heavy Rock',
	},
	{
		id: 21,
		image: images.motorhead2,
		title: 'The Löst Tapes, Vol. 2 (Live in Norwich, 1998)',
		date: 'December 24th, 2021',
		band: 'Mötorhead',
		length: '(47:40)',
		genre: 'Death Metal',
	},
	{
		id: 22,
		image: images.neaera1,
		title: 'All is dust',
		date: 'June 28th, 2024',
		band: 'Neaera',
		length: '(47:40)',
		genre: 'Death Metal',
	},
	{
		id: 23,
		image: images.neckbreakker1,
		title: 'Within The viscera',
		date: 'December 06th, 2024',
		band: 'Neckbreakker',
		length: '(46:09)',
		genre: 'Death Metal',
	},
	{
		id: 24,
		image: images.necrovation1,
		title: 'Necrovation',
		date: 'July 17th, 2012',
		band: 'Necrovation',
		length: '(46:40)',
		genre: 'death metal',
	},

	{
		id: 25,
		image: images.nineinchnails2,
		title: 'Pretty Hate Machine',
		date: 'October 20th, 1989',
		band: 'Nine Inch Nails',
		length: '(48:47)',
		genre: 'Industrial Rock',
	},
	{
		id: 26,
		image: images.opeth1,
		title: 'Ghost reveries',
		date: 'August 30th, 2005',
		band: 'Opeth',
		length: '(66:46)',
		genre: 'Doom Death Metal, Progressive Metal',
	},
	{
		id: 27,
		image: images.opeth2,
		title: 'Watershed limited 4000 copies',
		date: 'June 08th, 2008',
		band: 'Opeth',
		length: '(55:01)',
		genre: 'Doom Death Metal, Progressive Metal',
	},
	{
		id: 28,
		image: images.orbitculture1,
		title: 'Death above life',
		date: 'October 03rd, 2025',
		band: 'Orbit Culture',
		length: '(48:34)',
		genre: 'Death Metal',
	},
	{
		id: 29,
		image: images.orbitculture2,
		title: 'Descent',
		date: 'August 18th, 2023',
		band: 'Orbit Culture',
		length: '(51:12)',
		genre: 'Death Metal',
	},
	{
		id: 30,
		image: images.palefaceswiss1,
		title: 'Cursed (The complete edition)',
		date: 'January 03rd, 2025',
		band: 'Paleface Swiss',
		length: '(48:11)',
		genre: 'Death core',
	},
	{
		id: 31,
		image: images.rainbow1,
		title: 'The Defginitive Osaka 1978 Final night',
		date: 'March 31st, 2023',
		band: 'Rainbow',
		length: '(111:0)',
		genre: 'Heavy Metal',
	},
	{
		id: 32,
		image: images.sacredreich1,
		title: 'awakening',
		date: 'August 23rd, 2019',
		band: 'Sacred Reich',
		length: '(31:28)',
		genre: 'Trash Metal',
	},
	{
		id: 33,
		image: images.serenityinmurder1,
		title: 'Timeless Reverie',
		date: 'February 28th, 2025',
		band: 'Serenity in Murder',
		length: '(41:32)',
		genre: 'symphonic death metal',
	},
	{
		id: 34,
		image: images.Slipknot1,
		title: 'Slipknot 25th anniversary',
		date: 'June 29th, 2024',
		band: 'Slipknot',
		length: '(102:37)',
		genre: 'Nu Metal',
	},
	{
		id: 35,
		image: images.systemofadown1,
		title: 'Toxicity',
		date: 'September 04th, 2001',
		band: 'System of a Down',
		length: '(44:02)',
		genre: 'Trash alternative Metal',
	},
	{
		id: 36,
		image: images.theblackdahlia1,
		title: 'Servitude',
		date: 'September 27th, 2024',
		band: 'The Black Dahlia Murder',
		length: '(32:49)',
		genre: 'Death Metal',
	},
	{
		id: 37,
		image: images.tool1,
		title: 'Undertow',
		date: 'January 01st, 1993',
		band: 'Tool',
		length: '(68:13)',
		genre: 'Underground Metal',
	},
	{
		id: 38,
		image: images.tool2,
		title: 'Aenima',
		date: 'September 17th, 1996',
		band: 'Tool',
		length: '(77:18)',
		genre: 'Underground Metal',
	},
	{
		id: 39,
		image: images.typeonegative1,
		title: 'Life is killing me',
		date: 'April 19th, 2024',
		band: 'Type O Negative',
		length: '(74:33)',
		genre: 'Goth Metal',
	},
	{
		id: 40,
		image: images.whitechapel1,
		title: 'Hymmns in Dissonance',
		date: 'March 07th, 2025',
		band: 'Whitechapel',
		length: '(43:17)',
		genre: 'Hardcore,Grindcore',
	},
	{
		id: 41,
		image: images.whileshesleeps1,
		title: 'This is the Six',
		date: 'August 13th, 2012',
		band: 'While She Sleeps',
		length: '(44:39)',
		genre: 'MetalCore',
	},
	{
		id: 42,
		image: images.Kerryking1,
		title: 'From Hell I Rise (Extended Deluxe Edition)',
		date: 'May 17th, 2026',
		band: 'Kerry king',
		length: '(66:03)',
		genre: 'Trash Metal',
	},
	{
		id: 43,
		image: images.suicidesilence1,
		title: 'Remember… You must die',
		date: 'March 13th, 2023',
		band: 'Suicide Silence',
		length: '(39:30)',
		genre: 'DeathCore',
	},
	{
		id: 44,
		image: images.immolation1,
		title: 'Descent',
		date: 'April 16th, 2026',
		band: 'Immolation',
		length: '(44:39)',
		genre: 'Death Metal',
	},
	{
		id: 46,
		image: images.korn1,
		title: 'Follow the Leader',
		date: 'August 18th, 1998',
		band: 'Korn',
		length: '(67:13)',
		genre: 'Nu Metal',
	},
	{
		id: 45,
		image: images.blacksabbath2,
		title: 'Live Evil',
		date: 'December 1st, 1982',
		band: 'Black Sabbath',
		length: '(83:18)',
		genre: 'Doom Metal',
	},
	{
		id: 46,
		image: images.unanimated1,
		title: 'Victory in blood',
		date: 'January 12th, 2022',
		band: 'Unanimated',
		length: '(47:13)',
		genre: 'Melodic Death/Black Metal',
	},
	{
		id: 47,
		image: images.converge1,
		title: 'Bloodmoon:I',
		date: 'November 21st, 2021',
		band: 'Converge/Chelsea Wolfe',
		length: '(58:47)',
		genre: 'Melodic Death/Dark sound',
	},
]
// Rock collection
export const rockcollection = [
	{
		id: 200,
		image: images.aha1,
		title: 'Time and time again - The ultimate',
		date: 'March 25th, 2016',
		band: 'A-ha',
		length: '(157:54)',
		genre: 'Rock pop',
	},
	{
		id: 201,
		image: images.beastieboys1,
		title: 'Licensed to Ill',
		date: 'November 15th, 1986',
		band: 'Beastie Boys',
		length: '(36:46)',
		genre: 'hip-hop',
	},
	{
		id: 202,
		image: images.brucespringsteen1,
		title: 'Born in the USA',
		date: 'June 04th, 1984',
		band: 'Bruce Springsteen',
		length: '(46:53)',
		genre: 'Rock',
	},
	{
		id: 203,
		image: images.catstevens1,
		title: 'Tea for the Tillerman',
		date: 'November 23rd, 1970',
		band: 'Cat Stevens',
		length: '(36:46)',
		genre: 'Folk',
	},
	{
		id: 204,
		image: images.chriscornell1,
		title: 'No One Sings Like You Anymore',
		date: 'December 11th, 2020',
		band: 'Chris Cornell',
		length: '(36:25)',
		genre: 'Rock',
	},
	{
		id: 205,
		image: images.chriscornell2,
		title: 'Euphoria morning',
		date: 'September 21st, 1999',
		band: 'Chris cornell',
		length: '(50:50)',
		genre: 'Rock',
	},
	{
		id: 206,
		image: images.deeppurple1,
		title: 'Machine Head',
		date: 'March 25th, 1972',
		band: 'Deep Purple',
		length: '(41:40)',
		genre: 'Rock',
	},
	{
		id: 207,
		image: images.deeppurple2,
		title: 'Deep Purple int the rock',
		date: 'January 01st, 1970',
		band: 'Deep Purple',
		length: '(43:50)',
		genre: 'Rock',
	},
	{
		id: 208,
		image: images.deeppurple3,
		title: 'Live Honk kong 2001',
		date: 'August 13th, 2021',
		band: 'Deep Purple',
		length: '(119:04)',
		genre: 'Rock',
	},
	{
		id: 209,
		image: images.deeppurple4,
		title: 'Made in Europe',
		date: 'November 13th, 1976',
		band: 'Deep Purple',
		length: '(45:47)',
		genre: 'Rock',
	},
	{
		id: 210,
		image: images.django1,
		title: 'Django unchainded Original Motion Picture Soundtrack',
		date: 'December 28th, 2012',
		band: 'Various Artists',
		length: '(54:28)',
		genre: 'Various',
	},
	{
		id: 211,
		image: images.eagles1,
		title: 'Hotel California',
		date: 'December 08th, 1976',
		band: 'Eagles',
		length: '(43:25)',
		genre: 'Rock, Rock Progressive',
	},
	{
		id: 212,
		image: images.genesis1,
		title: 'A Trick of the Tail',
		date: 'February 06th, 1976',
		band: 'Genesis',
		length: '(51:22)',
		genre: 'Rock Progressive',
	},
	{
		id: 213,
		image: images.genesis2,
		title: 'Trepass',
		date: 'October 01st, 1970',
		band: 'Genesis',
		length: '(42:40)',
		genre: 'Rock',
	},
	{
		id: 214,
		image: images.georgemichael1,
		title: 'Older',
		date: 'April 01st, 1996',
		band: 'George Michael',
		length: '(58:88)',
		genre: 'Pop Jazz Soul',
	},
	{
		id: 215,
		image: images.georgemichael2,
		title: 'Faith',
		date: 'October 30th, 1987',
		band: 'George Michael',
		length: '(51:34)',
		genre: 'Pop Jazz Soul',
	},
	{
		id: 216,
		image: images.gretavanfleet1,
		title: "The Battle at Garden's Gate",
		date: 'June 09th, 2023',
		band: 'Greta Van Fleet',
		length: '(63:32)',
		genre: 'Rock',
	},
	{
		id: 217,
		image: images.gretavanfleet2,
		title: 'From the Fires',
		date: 'November 10th, 2017',
		band: 'Greta Van Fleet',
		length: '(32:11)',
		genre: 'Rock',
	},
	{
		id: 218,
		image: images.gretavanfleet3,
		title: 'Startcatcher',
		date: 'July 21st, 2023',
		band: 'Greta Van Fleet',
		length: '(42:49)',
		genre: 'Rock',
	},
	{
		id: 219,
		image: images.gretavanfleet4,
		title: 'Anthem of a peacfull army',
		date: 'October 19th, 2018',
		band: 'Greta Van Fleet',
		length: '(49:34)',
		genre: 'Rock',
	},
	{
		id: 287,
		image: images.gretavanfleet5,
		title: 'Palace for the people',
		date: 'October 9th, 2026',
		band: 'Greta Van Fleet',
		length: '(58:21)',
		genre: 'Rock',
	},
	{
		id: 220,
		image: images.gunsandroses1,
		title: 'Greatest Hits',
		date: 'March 23rd, 2004',
		band: "Guns N' Roses",
		length: '(72:14)',
		genre: 'Hard Rock',
	},
	{
		id: 221,
		image: images.iggypop1,
		title: 'Iggy Pop & David Bowie – Live At The Rainbow Theatre March 1977 (Radio Broadcast)',
		date: 'June 30th, 2023',
		band: 'Iggy Pop & David Bowie',
		length: '(40:36)',
		genre: 'Punk',
	},
	{
		id: 222,
		image: images.inxs1,
		title: 'Kick',
		date: 'January 01st, 1987',
		band: 'INXS',
		length: '(39:52)',
		genre: 'Rock',
	},
	{
		id: 223,
		image: images.janisjoplin1,
		title: 'Live In Amsterdam 1969, US Radio Shows 1969-70',
		date: 'November 16th, 2016',
		band: 'Janis Joplin',
		length: '(40:25)',
		genre: 'Rock, Blues',
	},
	{
		id: 224,
		image: images.jeffbuckley1,
		title: 'Grace',
		date: 'August 23rd, 1994',
		band: 'Jeff Buckley',
		length: '(57:09)',
		genre: 'Rock',
	},
	{
		id: 225,
		image: images.johnlennon1,
		title: 'Imagine',
		date: 'September 09th, 1971',
		band: 'John Lennon',
		length: '(39:44)',
		genre: 'Rock, pop, experimental',
	},
	{
		id: 226,
		image: images.johnnycash1,
		title: 'American IV: The Man Comes Around',
		date: 'November 05th, 2002',
		band: 'Johnny Cash',
		length: '(51:45)',
		genre: 'County Rock',
	},
	{
		id: 227,
		image: images.johnnycash2,
		title: 'With his hot and blue guitar (limited edition blue vinyl)',
		date: 'July 16th, 2021',
		band: 'Johnny Cash',
		length: '(27:22)',
		genre: 'Country-Rock',
	},
	{
		id: 228,
		image: images.johnnycash3,
		title: 'American V: A Hundred Highways',
		date: 'July 04th, 2006',
		band: 'Johnny Cash',
		length: '(42:50)',
		genre: 'Country Rock',
	},
	{
		id: 229,
		image: images.kingcrimson1,
		title: 'In the court of the crimson king',
		date: 'October 10th, 1969',
		band: 'King Crimson',
		length: '(67:42)',
		genre: 'Rock Progressive',
	},
	{
		id: 230,
		image: images.lennykravitz1,
		title: '5',
		date: 'May 12th, 1998',
		band: 'Lenny Kravitz',
		length: '(75:50)',
		genre: 'Rock',
	},
	{
		id: 231,
		image: images.michaeljackson1,
		title: 'Ben',
		date: 'August 04th, 1972',
		band: 'Michael Jackson',
		length: '(31:13)',
		genre: 'R and B, Soul',
	},
	{
		id: 232,
		image: images.nazareth1,
		title: 'Hair of the Dog',
		date: 'April 03rd, 1975',
		band: 'Nazareth',
		length: '(78:21)',
		genre: 'Rock',
	},
	{
		id: 233,
		image: images.neildiamond1,
		title: 'Jonathan levingston Seagull',
		date: 'October 01st,1973',
		band: 'Neil Diamond',
		length: '(43:28)',
		genre: 'Rock, pop rock',
	},
	{
		id: 234,
		image: images.nickcave1,
		title: 'The firtborn is dead',
		date: 'June 03rd, 1985',
		band: 'Nick Cave',
		length: '(40:36)',
		genre: 'Gothic, post punk',
	},
	{
		id: 235,
		image: images.nickcave2,
		title: 'Live God',
		date: 'December 5th, 2025',
		band: 'Nick Cave and the Bad Seeds',
		length: '(99:14)',
		genre: 'Goth Post punk',
	},
	{
		id: 236,
		image: images.nineinchnails1,
		title: 'The Downward Spiral',
		date: 'July 23rd, 1984',
		band: 'Nine Inch Nails',
		length: '(65:07)',
		genre: 'Industrial Rock',
	},
	{
		id: 237,
		image: images.phillipboa1,
		title: 'Reduced',
		date: 'January 1st, 2013',
		band: 'Phillip Boa',
		length: '(70:54)',
		genre: 'Rock',
	},
	{
		id: 238,
		image: images.pinkfloyd1,
		title: 'Meddle',
		date: 'November 11th, 1971',
		band: 'Pink Floyd',
		length: '(46:46)',
		genre: 'Rock progressive',
	},
	{
		id: 239,
		image: images.pinkfloyd2,
		title: 'Wish you were here',
		date: 'September 02nd, 1975',
		band: 'Pink Floyd',
		length: '(44:13)',
		genre: 'Rock progressive',
	},
	{
		id: 240,
		image: images.pinkfloyd3,
		title: 'Dark Side of the Moon',
		date: 'March 01st, 1973',
		band: 'Pink Floyd',
		length: '(40:25)',
		genre: 'Rock Progressive',
	},
	{
		id: 241,
		image: images.pinkfloyd4,
		title: 'Relics',
		date: 'May 14th, 1971',
		band: 'Pink Floyd',
		length: '(49:38)',
		genre: 'Rock Progressive',
	},
	{
		id: 242,
		image: images.pinkfloyd5,
		title: 'The wall',
		date: 'November 30th, 1979',
		band: 'Pink Floyd',
		length: '(81:03)',
		genre: 'Rock Progressive',
	},
	{
		id: 243,
		image: images.pinkfloyd6,
		title: 'Pink floyd live at Pompeii',
		date: 'May 2nd, 2026',
		band: 'Pink Floyd',
		length: '(88:31)',
		genre: 'Rock psychedelic',
	},
	{
		id: 244,
		image: images.polyphia1,
		title: 'Remember that you will die',
		date: 'October 28th 2022',
		band: 'Polyphia',
		length: '(39:08)',
		genre: 'Rock progressive',
	},
	{
		id: 245,
		image: images.portishead1,
		title: 'Dummy',
		date: 'October 01st, 1994',
		band: 'Portishead',
		length: '(49:15)',
		genre: 'Trip-hop',
	},
	{
		id: 246,
		image: images.prince1,
		title: '1999',
		date: 'October 27th, 1982',
		band: 'Prince',
		length: '(70:24)',
		genre: 'Funk Rock',
	},
	{
		id: 247,
		image: images.prince2,
		title: 'Purple Rain',
		date: 'June 29th, 1984',
		band: 'Prince and the revolution',
		length: '(43:51)',
		genre: 'Funk Rock',
	},
	{
		id: 248,
		image: images.prince3,
		title: 'Parade',
		date: 'March 31st, 1986',
		band: 'Prince and the revolution',
		length: '(41:00)',
		genre: 'Funk Rock',
	},
	{
		id: 249,
		image: images.puscifer1,
		title: 'Existential reckoning rewired',
		date: 'March 31st, 2023',
		band: 'Puscifer',
		length: '(60:01)',
		genre: 'Rock',
	},
	{
		id: 250,
		image: images.queen1,
		title: 'Innuendo',
		date: 'February 01st, 1991',
		band: 'Queen',
		length: '(53:55)',
		genre: 'Rock',
	},
	{
		id: 251,
		image: images.radiohead1,
		title: 'the bends',
		date: 'April 04th, 1995',
		band: 'Radiohead',
		length: '(48:34)',
		genre: 'Rock, Alternative Rock',
	},
	{
		id: 252,
		image: images.radiohead2,
		title: 'Ok computer',
		date: 'July 01st, 1997',
		band: 'Radiohead',
		length: '(53:36)',
		genre: 'Rock, Alternative Rock',
	},
	{
		id: 253,
		image: images.radiohead3,
		title: 'Kid A MNESIA',
		date: 'November 05th 2021',
		band: 'Radiohead',
		length: '(125:05)',
		genre: 'Rock, Alternative Rock',
	},
	{
		id: 254,
		image: images.rageagainstthemachine1,
		title: 'Rage Against the Machine',
		date: 'May 12th, 1998',
		band: 'Rage Against the Machine',
		length: '(52:53)',
		genre: 'Hardcore Punk',
	},
	{
		id: 255,
		image: images.rem1,
		title: 'New Adventures in Hi-Fi',
		date: 'September 10th, 1996',
		band: 'R.E.M.',
		length: '(65:31)',
		genre: 'Rock',
	},
	{
		id: 256,
		image: images.rem2,
		title: 'The best of R.E.M In time 1988-2003',
		date: 'October 28th, 2003',
		band: 'R.E.M',
		length: '(76:07)',
		genre: 'Rock',
	},
	{
		id: 257,
		image: images.simpleminds1,
		title: 'New Gold Dream (81–82–83–84)',
		date: 'September 01st, 1982',
		band: 'Simple Minds',
		length: '(44:59)',
		genre: 'Rock, Rock Progressive',
	},
	{
		id: 258,
		image: images.simpleminds2,
		title: 'Sparkle in the Rain',
		date: 'February 06th, 1984',
		band: 'Simple Minds',
		length: '(44:58)',
		genre: 'Rock, Rock Progressive',
	},
	{
		id: 259,
		image: images.simonandgarfunkel1,
		title: 'Sounds of Silence',
		date: 'January 01st, 1966',
		band: 'Simon & Garfunkel',
		length: '(29:27)',
		genre: 'Folk-Rock',
	},
	{
		id: 260,
		image: images.statusquo1,
		title: 'The Early Works',
		date: 'December  15th, 1990',
		band: 'Status Quo',
		length: '(140:13)',
		genre: 'Rock',
	},
	{
		id: 261,
		image: images.stereophonics1,
		title: 'Graffiti on the Train',
		date: 'March 12th, 2013',
		band: 'Stereophonics',
		length: '(43:09)',
		genre: 'Rock',
	},
	{
		id: 262,
		image: images.supertramp1,
		title: 'Indelibly Stamped',
		date: 'June 25th, 1971',
		band: 'Supertramp',
		length: '(40:06)',
		genre: 'Rock',
	},
	{
		id: 263,
		image: images.supertramp2,
		title: '...Famous Last Words...',
		date: 'October 06th, 1982',
		band: 'Supertramp',
		length: '(47:58)',
		genre: 'Rock',
	},
	{
		id: 264,
		image: images.supertramp3,
		title: 'Supertramp',
		date: 'July 14th, 1970',
		band: 'Supertramp',
		length: '(47:50)',
		genre: 'Rock',
	},
	{
		id: 265,
		image: images.supertramp4,
		title: 'Breakfast in America',
		date: 'March 16th, 1979',
		band: 'Supertramp',
		length: '(46:14)',
		genre: 'Rock',
	},
	{
		id: 266,
		image: images.supertramp5,
		title: 'Crisis? What Crisis?',
		date: 'January 01st, 1975',
		band: 'Supertramp',
		length: '(47:40)',
		genre: 'Rock',
	},
	{
		id: 267,
		image: images.supertramp6,
		title: 'Even in quietest moments...',
		date: 'January 01st, 1977',
		band: 'Supertramp',
		length: '(43:37)',
		genre: 'Rock',
	},
	{
		id: 268,
		image: images.talkingheads1,
		title: 'Stop making sense',
		date: 'October 23rd, 1984',
		band: 'Talking heads',
		length: '(74:24)',
		genre: 'Punk rock, New wave',
	},
	{
		id: 269,
		image: images.téléphone1,
		title: 'Best Of',
		date: 'November 24th 2000',
		band: 'Téléphone',
		length: '(65:34)',
		genre: 'Rock',
	},
	{
		id: 270,
		image: images.theclash1,
		title: 'London Calling Eu pressing',
		date: 'December 14th, 1979',
		band: 'The clash',
		length: '(65:08)',
		genre: 'Punk Rock',
	},
	{
		id: 271,
		image: images.thecure1,
		title: 'Desintegration',
		date: 'May 02nd, 1989',
		band: 'The Cure',
		length: '(72:03)',
		genre: 'Gothic Rock',
	},
	{
		id: 272,
		image: images.thecure2,
		title: 'Songs of the lost world',
		date: 'November  01st, 2024',
		band: 'The cure',
		length: '(49:13)',
		genre: 'Gothic Rock',
	},
	{
		id: 273,
		image: images.thepolice1,
		title: "Come Back Boys, All's Forgiven",
		date: 'June  15th, 1986',
		band: 'The police',
		length: '(49:13)',
		genre: 'Rock',
	},
	{
		id: 274,
		image: images.therollingstones1,
		title: 'Their Satanic Majesties Request',
		date: 'December 08th, 1967',
		band: 'The Rolling Stones',
		length: '(44:08)',
		genre: 'Rock',
	},
	{
		id: 275,
		image: images.therollingstones2,
		title: "Get yer ya-ya's out!",
		date: 'September  04th, 1970',
		band: 'The Rolling Stones',
		length: '(47:39)',
		genre: 'Rock',
	},
	{
		id: 276,
		image: images.thesmile1,
		title: 'A light for attracting attention',
		date: 'May 13th, 2022',
		band: 'The smile',
		length: '(53:12)',
		genre: 'Alternative Rock',
	},
	{
		id: 277,
		image: images.thewhitestripes1,
		title: 'Elephant',
		date: 'April 01st 2003',
		band: 'The White Stripes',
		length: '(50:54)',
		genre: 'Rock',
	},
	{
		id: 278,
		image: images.U21,
		title: 'Achtung Baby',
		date: 'November 18th, 1991',
		band: 'U2',
		length: '(55:27)',
		genre: 'Rock',
	},
	{
		id: 279,
		image: images.yes1,
		title: 'Going for the One',
		date: 'July 07th, 1977',
		band: 'Yes',
		length: '(38:55)',
		genre: 'Rock, Rock Progressive',
	},
	{
		id: 280,
		image: images.yes2,
		title: 'Relayer',
		date: 'December 05th, 1974',
		band: 'Yes',
		length: '(40:29)',
		genre: 'Rock, Rock Progressive',
	},
	{
		id: 281,
		image: images.pulpfiction1,
		title: 'Pulp Fiction',
		date: 'January 01st, 1994',
		band: 'Various artist',
		length: '(41:22)',
		genre: 'Various',
	},
	{
		id: 282,
		image: images.selig1,
		title: 'Selig - Die besten 1984-2014',
		date: 'May 22nd, 2020',
		band: 'Selig',
		length: '(51:20)',
		genre: 'Deutsch Pop Rock',
	},
	{
		id: 283,
		image: images.davidbowie1,
		title: 'David Bowie Narrates Prokofiev(s) Peter and the Wolf',
		date: 'May 2nd, 1978',
		band: 'David Bowie',
		length: '(67:42)',
		genre: 'Classical Music, Rock',
	},
	{
		id: 284,
		image: images.placebo1,
		title: '30th Anniversary',
		date: 'June 19th, 2026',
		band: 'Placebo',
		length: '(76:16)',
		genre: 'Rock',
	},
		{
		id: 285,
		image: images.redhotchilipeppers1,
		title: 'Greatest Hits',
		date: 'November 18th, 2003',
		band: 'Red Hot Chili Peppers',
		length: '(66:49)',
		genre: 'Rock',
	},
		{
		id: 286,
		image: images.tracychapman1,
		title: 'Tracy Chapman',
		date: 'January 01st, 1988',
		band: 'Tracy Chapman',
		length: '(36:09)',
		genre: 'Rock',
	},
		{
		id: 287,
		image: images.rush1,
		title: '212 liquid vinyl special edition',
		date: 'October 2nd, 2026',
		band: 'Rush',
		length: '(36:09)',
		genre: 'Rock',
	},
]
// Aderito Pereira collection
export const aderitopereira = [
	{
		id: 400,
		image: images.depechemode1,
		title: 'Violator',
		date: 'March 19th, 1990',
		band: 'Depeche Mode',
		length: '(47:03)',
		genre: 'Electronic, New Wave',
	},
	{
		id: 401,
		image: images.depechemode2,
		title: 'Black Celebration',
		date: 'March 17th, 1987',
		band: 'Depeche Mode',
		length: '(55:13)',
		genre: 'Electronic, New Wave',
	},
	{
		id: 402,
		image: images.depechemode5,
		title: 'Memento mori Mexico city',
		date: 'November 14th, 2025',
		band: 'Depeche Mode',
		length: '(140:44)',
		genre: 'Electronic, New Wave',
	},
	{
		id: 403,
		image: images.depechemode4,
		title: 'Speak & Spell',
		date: 'October 21st, 1981',
		band: 'Depeche Mode',
		length: '(61:58)',
		genre: 'Electronic, New Wave',
	},
	{
		id: 404,
		image: images.depechemode3,
		title: 'Music for the Masses',
		date: 'September 28th, 1988',
		band: 'Depeche Mode',
		length: '(61:58)',
		genre: 'Electronic, New Wave',
	},
	{
		id: 405,
		image: images.depechemode6,
		title: 'New Life',
		date: 'June 13th, 1981',
		band: 'Depeche Mode',
		length: '(11:27)',
		genre: 'Electronic, New Wave',
	},
	{
		id: 406,
		image: images.depechemode7,
		title: 'Hot Shot',
		date: 'September 28th, 1988',
		band: 'Depeche Mode',
		length: '(49:40)',
		genre: 'Electronic, New Wave',
	},
	{
		id: 407,
		image: images.depechemode8,
		title: 'Everything counts/Nothing',
		date: 'February 13th, 1989',
		band: 'Depeche Mode',
		length: '(11:11)',
		genre: 'Electronic, New Wave',
	},
	{
		id: 408,
		image: images.depechemode9,
		title: 'Leave 12inch single',
		date: 'August 16th, 1982',
		band: 'Depeche Mode',
		length: '(16:06)',
		genre: 'Electronic, New Wave',
	},
	{
		id: 409,
		image: images.depechemode10,
		title: 'Enjoy The Silence (The Quad: Final Mix)',
		date: 'February 05th, 1990',
		band: 'Depeche Mode',
		length: '(15:30)',
		genre: 'Electronic, New Wave',
	},
	{
		id: 410,
		image: images.depechemode11,
		title: 'World In My Eyes / Happiest Girl',
		date: 'September 17th, 1990',
		band: 'Depeche Mode',
		length: '(30:15)',
		genre: 'Electronic, New Wave',
	},
	{
		id: 411,
		image: images.depechemode12,
		title: 'Walking in my shoes Limited edition',
		date: 'April 26th, 1993',
		band: 'Depeche Mode',
		length: '(23:54)',
		genre: 'Electronic, New Wave',
	},
	{
		id: 412,
		image: images.depechemode13,
		title: '101',
		date: 'March 13th, 1989',
		band: 'Depeche Mode',
		length: '(95:45)',
		genre: 'Electronic, New Wave',
	},
	{
		id: 413,
		image: images.depechemode14,
		title: 'Do it if you want',
		date: 'July 6th, 1985 ',
		band: 'Depeche Mode',
		length: '(47:45)',
		genre: 'Electronic, New Wave',
	},
	{
		id: 414,
		image: images.depechemode15,
		title: 'A Question of time / Question of lust Limited edition',
		date: 'April 10th, 1986',
		band: 'Depeche Mode',
		length: '(22:40)',
		genre: 'Electronic, New Wave',
	},
	{
		id: 415,
		image: images.depechemode16,
		title: 'Never Let Me Down Again (Tsangarides Mix) UK',
		date: 'August 24th, 1987',
		band: 'Depeche Mode',
		length: '(11:42)',
		genre: 'Electronic, New Wave',
	},
	{
		id: 416,
		image: images.depechemode17,
		title: 'Depeche Mode – I Feel You',
		date: 'February 9th, 1993',
		band: 'Depeche Mode',
		length: '(44:29)',
		genre: 'Electronic, New Wave',
	},
	{
		id: 417,
		image: images.depechemode18,
		title: 'Behind The Wheel (Remixed By Shep Pettibone)',
		date: 'December 28th, 1987',
		band: 'Depeche Mode',
		length: '(12:14)',
		genre: 'Electronic, New Wave',
	},
	{
		id: 418,
		image: images.depechemode19,
		title: 'Behind The Wheel / Route 66 (Megamix)',
		date: 'April 5th, 1988',
		band: 'Depeche Mode',
		length: '(27:14)',
		genre: 'Electronic, New Wave',
	},
	{
		id: 420,
		image: images.depechemode20,
		title: 'Master And Servant (Slavery Whip Mix)',
		date: 'August 20th, 1984',
		band: 'Depeche Mode',
		length: '(20:23)',
		genre: 'Electronic, New Wave',
	},
	{
		id: 421,
		image: images.depechemode21,
		title: 'People Are People (Different Mix)',
		date: 'March 12th, 1984',
		band: 'Depeche Mode',
		length: '(15:23)',
		genre: 'Electronic, New Wave',
	},
	{
		id: 422,
		image: images.depechemode22,
		title: 'Enjoy The Silence (Remix)',
		date: 'February 5th, 1990',
		band: 'Depeche Mode',
		length: '(19:13)',
		genre: 'Electronic, New Wave',
	},
	{
		id: 423,
		image: images.depechemode23,
		title: 'The world we live in',
		date: 'April 1st, 1985',
		band: 'Depeche Mode',
		length: '(75:10)',
		genre: 'Electronic, New Wave',
	},
	{
		id: 424,
		image: images.depechemode24,
		title: 'A Question Of Time (Extended Remix)',
		date: 'August 11th, 1986',
		band: 'Depeche Mode',
		length: '(22:53)',
		genre: 'Electronic, New Wave',
	},
	{
		id: 425,
		image: images.depechemode25,
		title: 'Love In Itself • 3',
		date: 'September 19th, 1983',
		band: 'Depeche Mode',
		length: '(19:29)',
		genre: 'Electronic, New Wave',
	},
	{
		id: 426,
		image: images.depechemode26,
		title: 'Strangelove - Maxi mix',
		date: 'Avril 27th, 1987',
		band: 'Depeche Mode',
		length: '(13:46)',
		genre: 'Electronic, New Wave',
	},
	{
		id: 427,
		image: images.depechemode27,
		title: "It's Called A Heart - Fly On The Windscreen",
		date: 'September 16th, 1985',
		band: 'Depeche Mode',
		length: '(24:06)',
		genre: 'Electronic, New Wave',
	},
	{
		id: 428,
		image: images.depechemode28,
		title: 'Construction time again',
		date: 'August 22nd, 1983',
		band: 'Depeche Mode',
		length: '(42:26)',
		genre: 'Electronic, New Wave',
	},
	{
		id: 429,
		image: images.depechemode29,
		title: 'Never Let Me Down Again (Tsangarides Mix) US',
		date: 'August 24th, 1988',
		band: 'Depeche Mode',
		length: '(11:48)',
		genre: 'Electronic, New Wave',
	},
	{
		id: 430,
		image: images.depechemode30,
		title: 'Memento mori',
		date: 'March 24th, 2023',
		band: 'Depeche Mode',
		length: '(50:24)',
		genre: 'Electronic, New Wave',
	},
	{
		id: 431,
		image: images.depechemode31,
		title: 'Strangelove - Highjack remix',
		date: 'August 23rd, 1988',
		band: 'Depeche Mode',
		length: '(24:11)',
		genre: 'Electronic, New Wave',
	},
]
